import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'
import { RightsRouteGuard } from '~/components/route-guards'
import { SupplyPage } from '~/components/routes/supply/supply-page'
import { withRoutePermissions, type PermissionRequirement } from '~/utils/rbac'

/**
 * Écran Supply. `supply.supply.timeline` est une ressource de liaison `selection` : la vue réseau
 * et la vue boutique partagent le tuple, c'est le périmètre d'affectation qui les distingue côté
 * serveur. L'écran n'a donc qu'une permission de lecture.
 */
const SUPPLY_TIMELINE_READ: PermissionRequirement = ['read', 'supply.supply.timeline']

export const Route = createFileRoute('/_authenticated/supply/')({
  staticData: {
    permission: SUPPLY_TIMELINE_READ,
  },
  component: SupplyRoute,
})
withRoutePermissions(Route)

function SupplyRoute(): JSX.Element {
  // Tant que `permission-v2` est OFF, le tuple v2 ne discrimine rien : le bit `STOCK_READER` reste
  // la garde effective de l'écran, comme avant la bascule. Sans lui, la page n'affichait qu'une
  // erreur de chargement permanente.
  return (
    <RightsRouteGuard permission={SUPPLY_TIMELINE_READ} legacyRights={['STOCK_READER']}>
      <SupplyPage />
    </RightsRouteGuard>
  )
}
